import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import {
  useGetInterviewQuery,
  useLazyQuestionnaireQuery,
} from "../../../redux/Hire/interviewQuestionSlice";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import { HiringStageCode } from "../../../utils/constants";
import ScheduledCallDialog from "../Compoenents/ScheduleCallDialog";
type Props = {
  candidate?: CandidateDetails;
  job: {
    jobId: string;
  };
};

const ShortlistStage = ({ candidate, job }: Props) => {
  const [pollingInterval, setPollingInterval] = useState<number | undefined>(
    5000,
  );

  const navigate = useNavigate();
  const { data: interviewData, isError } = useGetInterviewQuery(
    {
      candidateId: candidate?.id.toString() || "",
      jobId: job?.jobId.toString() || "",
    },
    {
      pollingInterval: pollingInterval,
      skip: !candidate?.id || !job?.jobId,
      refetchOnMountOrArgChange: true,
    },
  );
  const { data, isFetching } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: HiringStageCode.SHORTLIST,
  });

  const [getQuestionnaire] = useLazyQuestionnaireQuery();

  useEffect(() => {
    if (
      (interviewData?.questionGenerationStatus === "FAILED" ||
        interviewData?.questionGenerationStatus === "PENDING") &&
      candidate?.id &&
      job?.jobId
    ) {
      getQuestionnaire({
        jobId: job?.jobId.toString() || "",
        candidateId: candidate?.id.toString() || "",
      });
    }
    if (interviewData?.questionGenerationStatus === "COMPLETED") {
      setPollingInterval(0);
    }
  }, [candidate?.id, getQuestionnaire, interviewData, job]);

  useEffect(() => {
    if (isError) {
      setPollingInterval(0);
    }
  }, [isError]);

  const goToInterviewQuestions = useCallback(() => {
    navigate(
      `/candidates/${candidate?.id}/?jobId=${job?.jobId}&stage=${HiringStageCode.SCREENING}`,
    );
  }, [candidate?.id, job?.jobId, navigate]);

  const [showDialog, setShowDialog] = useState<boolean>(false);
  const handleCloseDialog = useCallback(() => setShowDialog(false), []);
  const handleOpenDialog = useCallback(() => setShowDialog(true), []);
  return (
    <Grid container gap={2} alignItems="center" wrap="nowrap">
      <Grid container item>
        {isFetching && <CircularProgress size={20} />}
        {!isFetching && data?.data.length === 0 && (
          <Typography fontSize={"14px"} color={"#0F1829"}>
            Call not yet scheduled
          </Typography>
        )}
        {!isFetching && (data?.data.length || 0) > 0 && (
          <>
            <Typography fontSize={"14px"} color={"#0F1829"}>
              Screening interview scheduled
            </Typography>
            <Typography fontSize={"14px"} color={"#0F1829"} fontWeight={700}>
              {moment
                .utc(data?.data[0].meetingStartedOn)
                .local()
                .format("Do MMMM YYYY, hh:mm a")}
            </Typography>
          </>
        )}
      </Grid>
      <Grid container item gap={1} flexGrow={0}>
        <Dialog open={showDialog} maxWidth="md" fullWidth>
          <DialogContent>
            <ScheduledCallDialog
              candidate={candidate}
              closeBox={handleCloseDialog}
            />
          </DialogContent>
        </Dialog>

        <Button variant="outlined" onClick={handleOpenDialog}>
          {!isFetching && (data?.data.length || 0) > 0
            ? "View Call Details"
            : "Schedule Call"}
        </Button>
        {interviewData?.questionGenerationStatus === "COMPLETED" &&
          interviewData?.questions.length > 0 && (
            <Button variant="outlined" onClick={goToInterviewQuestions}>
              View Interview Questions
            </Button>
          )}
      </Grid>
    </Grid>
  );
};

export default ShortlistStage;
